//#region libraries
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';

//redux
import { selectThirtyMinLayout, setThirtyMinLayout } from '_redux/slices/timeline/timeline-control';
import { selectUsedTheme } from '_redux/slices/timeline/theme';

//bootstrap
import { Col, Form } from 'react-bootstrap';

//tremor
import { Flex, Subtitle, Title } from '@tremor/react';

//custom components
import { Card } from '_components/atoms';

//#endregion
const ThirtyMinLayoutSwitch = () => {

    //redux
    const dispatch = useDispatch();
    const thirtyMinLayout = useSelector(selectThirtyMinLayout);
    const usedTheme = useSelector(selectUsedTheme);

    const handleSwitch = () => {
        dispatch(setThirtyMinLayout(!thirtyMinLayout));
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '20px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: '16px', color: 'gray', fontWeight: '500' }}>
                    30 Minute Layout
                </span>
                <Form.Check
                    onChange={handleSwitch}
                    type="switch"
                    checked={thirtyMinLayout}
                    value={thirtyMinLayout}
                //disabled={true}
                />
            </div>
            <span style={{ color: usedTheme.TEXT_COLOR, fontSize: '14px', marginTop: '4px' }}>
                This feature allows you to view the timeline in 30-minute intervals, providing a more detailed view of your schedule.
            </span>
        </div>
    )
}

export default ThirtyMinLayoutSwitch